export type CallReply = { kind: "call" | "message"; id: string; said: string };

export function callReplyIn(value: unknown): CallReply | null {
  if (!value || typeof value !== "object") return null;
  const held = value as Partial<CallReply>;
  if ((held.kind !== "call" && held.kind !== "message") || typeof held.id !== "string") return null;
  return typeof held.said === "string" ? { kind: held.kind, id: held.id, said: held.said } : null;
}

export function callReplyBelongs(
  reply: CallReply | null,
  call: string,
  discussion: readonly { id: string }[],
): boolean {
  if (!reply) return false;
  return reply.kind === "call" ? reply.id === call : discussion.some((line) => line.id === reply.id);
}
